<template>
	<div>
		<svg
			:width="iconSize"
			:height="iconSize"
			viewBox="0 0 25 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M12.5005 5.99372C10.7678 4.44296 8.47979 3.5 5.97151 3.5C4.82687 3.5 3.72809 3.69637 2.70703 4.05727V19.5635C3.72809 19.2027 4.82687 19.0063 5.97151 19.0063C8.47979 19.0063 10.7678 19.9492 12.5005 21.5M12.5005 5.99372C14.2331 4.44296 16.5212 3.5 19.0294 3.5C20.1741 3.5 21.2729 3.69637 22.2939 4.05727V19.5635C21.2729 19.2027 20.1741 19.0063 19.0294 19.0063C16.5212 19.0063 14.2331 19.9492 12.5005 21.5M12.5005 5.99372V21.5"
				:stroke="color"
				stroke-width="1.56"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgBook',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<style scoped></style>
